import React, { useState, useEffect, useRef } from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './howItWorks.module.css';
import { gsap, TweenMax, Expo } from "gsap";

function howItWorks(props) {

    const sectionRef = useRef();
    const textRef = useRef();
    const imageRef = useRef();
    const circleLeftRef = useRef();
    const circleRightRef = useRef();

    useEffect(() => {
        
        let isInViewport = (ins, os) => {
            let offset = (os) ? os : 0;
            if(ins.offset()){
                let elementTop = ins.offset().top + 10 - offset;
                let elementBottom = elementTop + ins.outerHeight() - offset;
                let viewportTop = $(window).scrollTop();
                let viewportBottom = viewportTop + $(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom;
            }
            return false;
        }

        // TweenMax.set([textRef.current], {
        //     opacity: 0,
        //     x: -80
        // });

        // TweenMax.set([imageRef.current], {
        //     opacity: 0,
        //     x: 80
        // });
        
        if(!$(sectionRef.current).hasClass('anim-complete')){
            $(window).on('scroll', () => {
                if(isInViewport($(sectionRef.current), (0-($(window).height()/4)) )){
                    // TweenMax.to(
                    //     textRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         x: 0, 
                    //         delay : 0.25
                    //     } 
                    // );

                    // TweenMax.to(
                    //     imageRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         x: 0, 
                    //         delay : 0.45,
                    //         onComplete : () => {
                    //             $(sectionRef.current).addClass('anim-complete');
                    //         }
                    //     } 
                    // );
                    
                }

                $(sectionRef.current).addClass('anim-complete');
                
                let scroll_factor = 4;
                let scroll_factor_alt = 6;
                let scroll_limit = 85;
                let ref_offset = $(sectionRef.current).offset();
                let scroll_pos = $(window).scrollTop();

                if(ref_offset){
                    if(scroll_pos > (ref_offset.top - $(window).height()) ){
                        let move_by = ((scroll_pos - ref_offset.top) / scroll_factor);
                        move_by = (move_by >= scroll_limit) ? scroll_limit : move_by;

                        TweenMax.to(circleLeftRef.current, 0.25, {
                            y : 0 - move_by
                        });

                        let move_by_alt = ((scroll_pos - ref_offset.top) / scroll_factor_alt);
                        move_by_alt = (move_by_alt >= scroll_limit) ? scroll_limit : move_by_alt;

                        TweenMax.to(circleRightRef.current, 0.25, {
                            y : 0 - move_by_alt
                        });
                    }
                }
            });
        }

    });

    return (
        <div className={styles.howItWorksSection} ref={sectionRef}>

            <div className={styles.circleLeft} ref={circleLeftRef}></div>
            <div className={styles.circleRight} ref={circleRightRef}></div>

            <div className={styles.sectionContainer}>
                <div className={styles.row}>
                    <div className={styles.col}>
                        <div className={styles.contentWrap} ref={textRef} >
                            <h2>{props.heading}</h2>
                            <PortableText blocks={props.content} />
                        </div>
                    </div>
                    <div className={styles.col} ref={imageRef}>
                        {
                            (props.appStore) ?
                            <div className={styles.appStore}>
                                <a href={props.appStore}>
                                    <img src={require('../images/apple.png').default} alt="App Store" />
                                </a>
                            </div>
                            : ``
                        }
                        {
                            (props.googlePlay) ?
                            <div className={styles.googlePlay}>
                                <a href={props.googlePlay}>
                                    <img src={require('../images/google.png').default} alt="App Store" />
                                </a>
                            </div>
                            : ``
                        }
                        {
                            (props.featuredImage.image) ?
                            <img src={props.featuredImage.image.asset.url} alt="" />
                            : ``
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default howItWorks;